export const confirmActionInitialState = {
  isDialogOpen: false
}

export type ConfirmActionState = typeof confirmActionInitialState
